import ChangePasswordModal from '@/features/change-password'
import { ROUTER } from '@/shared/config'
import { useIsLogin } from '@/shared/context'
import { clearAuthSession } from '@/shared/lib/storage'
import { queryClient } from '@/shared/queries'
import { changeAuthorization, setListMenu, setListTabs, setUserInfo } from '@/shared/redux'
import { PenLineOutlined as PenLine, UserOutlined as User } from '@/shared/ui/icons'
import LinkCusstom from '@/shared/ui/link-custom'
import SvgIcon from '@/shared/ui/svg-icon'
import UiDivider from '@/shared/ui/ui-divider'
// ds-guard-ignore: vi phạm có sẵn trước khi chuyển từ components (C3)
import { Menu } from 'antd'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import UserProfileModal from '../../UserProfileModal'
import { StyleMenuAccount } from '../styles'

const MenuUser = () => {
  const { userInfo } = useSelector((state: any) => state?.appGlobal)
  const { isLogin } = useIsLogin()
  const dispatch = useDispatch()
  const [profileOpen, setProfileOpen] = useState(false)
  const [changePasswordOpen, setChangePasswordOpen] = useState(false)

  const navigate = useNavigate()
  const location = useLocation()

  const getActiveKey = (): string[] => {
    const currentPath = location.pathname || ''
    if (currentPath.startsWith('/user')) {
      return ['3']
    }
    return []
  }

  const activeKey = getActiveKey()

  const handleLogout = async () => {
    if (isLogin) {
      clearAuthSession()
      dispatch(setUserInfo({}))
      dispatch(setListTabs([]))
      dispatch(setListMenu(null))
      dispatch(changeAuthorization(false))
      queryClient.clear()
      // Về thẳng màn đăng nhập, không về trang chủ — đã xoá token thì mọi màn trong đều chặn.
      return navigate(ROUTER.LOGIN, { replace: true })
    }
  }

  return (
    <>
      <StyleMenuAccount>
        <div className="menu-account">
          <div className="account-infor">
            <div
              style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '8px 12px 10px' }}
            >
              <div
                className="header-avatar-rainbow"
                style={{ width: 40, height: 40, flexShrink: 0 }}
              >
                <img
                  src={userInfo?.avatar || '/user-holder.svg'}
                  alt="Avatar"
                  onError={(e) => {
                    const target = e.currentTarget
                    if (!target.src.endsWith('/user-holder.svg')) {
                      target.src = '/user-holder.svg'
                    }
                  }}
                />
              </div>
              <div className="sumary-infor-user" style={{ minWidth: 0, flex: 1 }}>
                <div
                  className="account-name"
                  style={{
                    fontSize: 14,
                    fontWeight: 600,
                    color: 'var(--vbdt-color-text-primary)',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                  title={userInfo?.fullName || userInfo?.username || 'Người dùng'}
                >
                  {userInfo?.fullName || userInfo?.username || 'Người dùng'}
                </div>
                {(userInfo?.email || userInfo?.username) && (
                  <div
                    style={{
                      fontSize: 12,
                      color: 'var(--vbdt-color-text-secondary)',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      marginTop: 2,
                    }}
                    title={userInfo?.email || `@${userInfo?.username}`}
                  >
                    {userInfo?.email || `@${userInfo?.username}`}
                  </div>
                )}
              </div>
            </div>
            <UiDivider style={{ margin: '4px 0 8px 0' }} />
          </div>

          <Menu className="dropdown-option" selectedKeys={activeKey}>
            <Menu.Item key="profile" onClick={() => setProfileOpen(true)}>
              <div
                className="btn-function"
                style={{ display: 'flex', color: 'inherit', alignItems: 'center', gap: 8 }}
              >
                <User size={16} />
                <span className="fw-400">Thông tin cá nhân</span>
              </div>
            </Menu.Item>

            <Menu.Item key="my-signature">
              <LinkCusstom
                to={ROUTER.CHU_KY_CUA_TOI}
                noUnderline={true}
                className="btn-function"
                style={{ display: 'flex', color: 'inherit', alignItems: 'center', gap: 8 }}
              >
                <PenLine size={16} />
                <span className="fw-400">Chữ ký của tôi</span>
              </LinkCusstom>
            </Menu.Item>

            <Menu.Item key="3" onClick={() => setChangePasswordOpen(true)}>
              <div className="btn-function" style={{ display: 'flex', color: 'inherit' }}>
                <SvgIcon name="reset-pass" />
                <span className="fw-400">Đổi mật khẩu </span>
              </div>
            </Menu.Item>

            {/* ds-guard-ignore: vi phạm có sẵn trước khi chuyển từ components (C3) */}
            <UiDivider className="m-0" />

            <Menu.Item
              key="6"
              style={{ color: 'var(--vbdt-color-status-error)' }}
              onClick={handleLogout}
            >
              <div className="btn-logout">
                <SvgIcon name="logoutIcon" />
                Đăng xuất
              </div>
            </Menu.Item>
          </Menu>
        </div>
      </StyleMenuAccount>
      <UserProfileModal open={profileOpen} onClose={() => setProfileOpen(false)} />
      <ChangePasswordModal open={changePasswordOpen} onClose={() => setChangePasswordOpen(false)} />
    </>
  )
}

export default MenuUser
